<div class="rectangle"
     mwlResizable
     [enableGhostResize]="true"
     ghostElementPositioning="absolute"
     (resizeEnd)="onResizeEnd($event)"
     [style.height.px]="mapHeight">
    <cl-bing-map [pins]="pins" [customBtn]="customBtn"> </cl-bing-map>
    <div class="resize-handle-bottom"
         mwlResizeHandle
         [resizeEdges]="{ bottom: true }">
        <mat-icon>drag_handle</mat-icon>
    </div>
</div>